export default function () {
  this.loadPrivacyPolicy()
}
